<script setup lang="ts">
    import { useCollapsibleContext } from './context';

    const { open, disabled, contentId, toggle } = useCollapsibleContext('CollapsibleTrigger');
</script>

<template>
    <button
        type="button"
        class="ui-collapsible-trigger"
        :aria-expanded="open"
        :aria-controls="contentId"
        :data-state="open ? 'open' : 'closed'"
        :disabled="disabled"
        @click="toggle"
    >
        <slot :open="open" />
    </button>
</template>

<style scoped>
    /* Below `utilities` so consumers' Tailwind classes override these defaults, above Bulma's `base` */
    @layer components {
        /* An unstyled button: the consumer lays out its content */
        .ui-collapsible-trigger {
            margin: 0;
            padding: 0;
            border: 0;
            border-radius: 0;
            background: none;
            color: inherit;
            font: inherit;
            text-align: inherit;
            outline: none;
            cursor: pointer;
        }

        .ui-collapsible-trigger:focus-visible {
            border-radius: 4px;
            box-shadow: 0 0 0 3px color-mix(in oklab, var(--color-ring) 70%, transparent);
        }

        .ui-collapsible-trigger:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }
</style>
